import React from "react";
import { Modal } from "react-bootstrap";

const ModalPDF = ({ show, handleClose, data, documento }) => {
  return (
    <div>
      <Modal
        animation={false}
        show={!!show}
        onHide={handleClose}
        size="xl"
        className="contribuyente-modal"
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <iframe
            src={`https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/actuaciones/${documento || data.documento}`}
            style={{
              width: "100%",
              minHeight: 500,
              height: "max-content",
              objectFit: "contain",
              display: "block",
            }}
            title={documento || data.documento}
          ></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalPDF;
